import styles from "./styles.module.scss";
import primaryComponents from "../../../../../../components/primaryComponents";
import { LinkArrow } from "../../../../../../assets/svgIcons";

const EditProductsMap = ({
  index,
  item,
  mappedUnmappedProducts,
  chowdeckLumiLinks,
  setChowdeckLumiLinks,
}) => {
  const itemExists = chowdeckLumiLinks?.find(
    (prod) => prod?.marketplace_product_ref === item?.marketplace_product_ref,
  );

  const lumiObjectTypeWithID = (lumi_object_type, lumi_object_id) => {
    if (lumi_object_type === "service") {
      return { service_id: lumi_object_id };
    } else if (lumi_object_type === "variant") {
      return { variant_id: lumi_object_id };
    } else {
      return { product_id: lumi_object_id };
    }
  };

  return (
    <div className={styles.linkItemContainer}>
      <div className={styles.chowdeckItem}>
        <div className="d-flex align-items-start">
          <primaryComponents.Checkbox
            name={`selectItem${index}`}
            id={`selectItem${index}`}
            isChecked={itemExists ? true : false}
            onChange={() => {
              if (itemExists) {
                setChowdeckLumiLinks(
                  chowdeckLumiLinks?.filter(
                    (prod) =>
                      prod?.marketplace_product_ref !==
                      item?.marketplace_product_ref,
                  ),
                );
              } else {
                setChowdeckLumiLinks([
                  ...chowdeckLumiLinks,
                  {
                    marketplace_product_ref: item?.marketplace_product_ref,
                    marketplace_product_name: item?.marketplace_product_name,
                    lumi_product: lumiObjectTypeWithID(
                      item?.mapped_to?.lumi_object_type,
                      item?.mapped_to?.lumi_object_id,
                    ),
                  },
                ]);
              }
            }}
          />
          <p className={styles.chowdeckItemName}>
            {item.marketplace_product_name.split(" ").map((name, index) => (
              <span key={index}>{name}&nbsp;</span>
            ))}
          </p>
        </div>
        <div className={styles.linkArrow}>
          <span>Link&nbsp;With</span>
          <LinkArrow />
        </div>
      </div>
      <div className={styles.lumiBusinessItem}>
        <primaryComponents.SelectField
          name="lumiItem"
          value={item?.mapped_to?.lumi_product_name || "Select an item"}
          options={mappedUnmappedProducts?.lumi?.map((item) => ({
            label: item?.lumi_product_name,
            value: item?.lumi_object_id,
          }))}
          nameKey="label"
          idKey="value"
          isDisabled={
            !chowdeckLumiLinks?.find(
              (prod) =>
                prod?.marketplace_product_ref === item?.marketplace_product_ref,
            )
          }
          onChange={(value) => {
            setChowdeckLumiLinks((prev) =>
              prev.map((prod) =>
                prod?.marketplace_product_ref === item?.marketplace_product_ref
                  ? {
                      marketplace_product_ref: item?.marketplace_product_ref,
                      marketplace_product_name: item?.marketplace_product_name,
                      lumi_product: lumiObjectTypeWithID(
                        mappedUnmappedProducts?.lumi?.find(
                          (prod) => prod.lumi_object_id === value,
                        )?.lumi_object_type,
                        value,
                      ),
                    }
                  : prod,
              ),
            );
          }}
        />
      </div>
    </div>
  );
};

export default EditProductsMap;
